import localforage from 'localforage';

const setupLocalForage = localforage.createInstance({
  name: 'GGC.Web',
});

export default setupLocalForage;